// Service Rule Master Types
export const SET_SERVICE_RULE_CONFIG = 'SET_SERVICE_RULE_CONFIG';
export const SET_SERVICE_RULE_LOADING = 'SET_SERVICE_RULE_LOADING';
export const SET_SERVICE_RULE_ERROR = 'SET_SERVICE_RULE_ERROR';
export const UPDATE_SERVICE_RULE_CONFIG = 'UPDATE_SERVICE_RULE_CONFIG';
export const CLEAR_SERVICE_RULE_ERROR = 'CLEAR_SERVICE_RULE_ERROR';
export const CLEAR_SERVICE_RULE_DATA = 'CLEAR_SERVICE_RULE_DATA';
export const CLEAR_ALL_SERVICE_RULE_DATA = 'CLEAR_ALL_SERVICE_RULE_DATA';

// Action Types
export interface SetServiceRuleConfigAction {
    type: typeof SET_SERVICE_RULE_CONFIG;
    payload: {
        configName: string;
        data: any;
    };
}

export interface SetServiceRuleLoadingAction {
    type: typeof SET_SERVICE_RULE_LOADING;
    payload: {
        configName: string;
        loading: boolean;
    };
}

export interface SetServiceRuleErrorAction {
    type: typeof SET_SERVICE_RULE_ERROR;
    payload: {
        configName: string;
        error: string | null;
    };
}

export interface UpdateServiceRuleConfigAction {
    type: typeof UPDATE_SERVICE_RULE_CONFIG;
    payload: {
        configName: string;
        updates: any;
    };
}

export interface ClearServiceRuleErrorAction {
    type: typeof CLEAR_SERVICE_RULE_ERROR;
    payload: {
        configName: string;
    };
}

export interface ClearServiceRuleDataAction {
    type: typeof CLEAR_SERVICE_RULE_DATA;
    payload: {
        configName: string;
    };
}

export interface ClearAllServiceRuleDataAction {
    type: typeof CLEAR_ALL_SERVICE_RULE_DATA;
}

export type ServiceRuleMasterActionType = 
    | SetServiceRuleConfigAction 
    | SetServiceRuleLoadingAction 
    | SetServiceRuleErrorAction 
    | UpdateServiceRuleConfigAction
    | ClearServiceRuleErrorAction
    | ClearServiceRuleDataAction
    | ClearAllServiceRuleDataAction;